var store = {
  state: {
    isLogin: false,
    currentRoute: '',
    currentTab: 0,
    navList: [
      {
        name: 'Front Page',
        link: '#home-page'
      },
      {
        name: 'NEWS',
        link: '#page-news'
      },
      {
        name: 'Retainer Preview',
        link: '#page-role'
      },
      {
        name: 'Game Features',
        link: '#page-game'
      },
    //   {
    //     name: 'Top-Up Center',
    //     link: '#page-game'
    //   }
    ]
  }
};

export default store;
